export default __webpack_public_path__ + "static/media/whatsapp.eb30cea0.svg";